import request from '@/utils/request';
export function fetchCorporationBalanceList(id, query) {
  return request({
    url: `/admin/balances/${id}`,
    method: 'get',
    params: query
  });
}
export function fetchOrder(query) {
  return request({
    url: '/admin/order',
    method: 'get',
    params: query
  });
}